import { render, staticRenderFns } from "./personGroupTab.vue?vue&type=template&id=138bf0c5&scoped=true&"
import script from "./personGroupTab.vue?vue&type=script&lang=js&"
export * from "./personGroupTab.vue?vue&type=script&lang=js&"
import style0 from "./personGroupTab.vue?vue&type=style&index=0&id=138bf0c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138bf0c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('138bf0c5')) {
      api.createRecord('138bf0c5', component.options)
    } else {
      api.reload('138bf0c5', component.options)
    }
    module.hot.accept("./personGroupTab.vue?vue&type=template&id=138bf0c5&scoped=true&", function () {
      api.rerender('138bf0c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/tabPane/personGroupTab.vue"
export default component.exports